export default __webpack_public_path__ + "static/media/arrowup-purple.f903de6c.svg";